import React from 'react';
import { createContext, useContext, useState } from "react";
import { useCollapsiblePanel } from '../component/ui/UI';
import { isProd } from '@MyLib/Debug/Debug';
import { useCounter } from '@MyLib/System/useCounter.js';

const AppContext = createContext();

export const AppProvider = ({children}) =>
{
	const running = useCounter();
	const [yesNoModal, setYesNoModal] = useState();

	const searchArtifactTypePanel = useCollapsiblePanel();
	const searchEnchantmentTypePanel = useCollapsiblePanel();
	const searchLandTypePanel = useCollapsiblePanel();
	const searchSpellTypePanel = useCollapsiblePanel();
	const searchCreatureTypePanel = useCollapsiblePanel();
	const searchBattleTypePanel = useCollapsiblePanel();
	const searchKeytypePanel = useCollapsiblePanel();
	const searchSetPanel = useCollapsiblePanel();
	const searchFrameEffectPanel = useCollapsiblePanel();
	const searchFrameEffectExcludePanel = useCollapsiblePanel();

	const [cardSearchCache, setCardSearchCache] = useState(null);

	const [cardSets, setCardSets] = useState([]);
	const [cardSetsLanguage, setCardSetsLanguage] = useState();
	const getCardSets = async (language) => {
		if (cardSets.length == 0)
		{
			if (cardSetsLanguage === language) {
				return;
			}
			setCardSetsLanguage(language);
		}
		try {
			const languageMap = {
				en: "English",
				ja: "Japanese"
			};
			const query = new URLSearchParams();
			query.append("language", languageMap[language] ?? languageMap.en);
			const res = await fetch(`${getEndpoint()}/mtg-sets-codes?${query.toString()}`);
			const data = await res.json();
			setCardSets(data);
		} catch (err) {
			console.error(err);
			setCardSets([]);
		}
	};

	// デッキビルダーのカードデータキャッシュ
	const [buildCardDatas, setBuildCardDatas] = useState([]);

	const [keepCards, setKeepCards] = useState([]);
	const addKeepCards = (card) => {
		const newKeepCards = [...keepCards, ...card];
		setKeepCards(newKeepCards);
	};
	const removeKeepCards = (card) => {
		const newKeepCards = keepCards.filter(item => item.uuid !== card.uuid || item.language !== card.language);
		setKeepCards(newKeepCards);
	};
	const findKeepCards = (card) => {
		return keepCards.find(item => item.uuid === card.uuid && item.language === card.language);
	};

	return (
		<AppContext.Provider
			value={{
				running: running.active,

				yesNoModal,
				setYesNoModal,

				searchArtifactTypePanel,
				searchEnchantmentTypePanel,
				searchLandTypePanel,
				searchSpellTypePanel,
				searchCreatureTypePanel,
				searchBattleTypePanel,
				searchKeytypePanel,
				searchSetPanel,
				searchFrameEffectPanel,
				searchFrameEffectExcludePanel,

				cardSearchCache,
				setCardSearchCache,

				cardSets,
				getCardSets,

				buildCardDatas,
				setBuildCardDatas,

				keepCards,
				setKeepCards,
				addKeepCards,
				removeKeepCards,
				findKeepCards,
			}}
		>
			{children}
		</AppContext.Provider>
	);
};

export const useApp = () => useContext(AppContext);

export const getEndpoint = () => {
	if (isProd() || process.env.API_LAN === "false")
	{
		return process.env.API_BASE;
	}

	const hostname = window.location.hostname;
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		return 'http://localhost:8080';
	}
	return `http://${hostname}:8080`;
};
export const getEndpointFunc = () => {
	if (isProd() || process.env.API_LAN === "false")
	{
		return process.env.API_FUNC;
	}

	const hostname = window.location.hostname;
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		return 'http://localhost:8080';
	}
	return `http://${hostname}:8080`;
};
